import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { AbSms } from 'app/abstract/full-pages/integrador/sms.abstract';

@Injectable({ providedIn: 'root' })
export class SmsService extends AbSms {

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    registrarConfiguracao(config: any) {
        return this.save("admin/sms_config/", config);
    }

    getConfigSmsByIntegradorId(codigo): Observable<any> {
        return this.get(`admin/sms_config/${codigo}`);
    }

    getTotalSmsMesAtualByIntegradorId(codigo): Observable<any> {
        return this.get(`admin/sms_view/total_mes_atual/${codigo}`);
    }

    getTotalSmsEnviadosUltimoAnoByIntegradorId(codigo): Observable<any> {
        return this.get(`admin/sms_view/total_ultimo_ano/${codigo}`);
    }

}